//
//
//
//
//
//
//
//
//
//
//

import {
  computed, defineComponent, toRefs, ref, useContext, watch, useAsync,
} from '@nuxtjs/composition-api';
import { createNamespacedHelpers } from 'vuex-composition-helpers';

const { useGetters: useGettersObrazki } = createNamespacedHelpers('obrazkiSvg');

export default defineComponent({
  props: {
    url: {
      type: String,
      required: true,
      default: '',
    },
    alt: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup(props) {
    const { store } = useContext();
    const { getImage } = useGettersObrazki(['getImage']);
    const { url } = toRefs(props);
    const root = ref();
    const svgIcon = computed(() => (getImage && url ? getImage.value(url.value) : null));

    useAsync(async () => {
      if (!svgIcon.value) {
        await store.dispatch('obrazkiSvg/fetchImage', url.value);
      }

      return svgIcon.value;
    });

    watch(
      url,
      async () => {
        if (url.value && !svgIcon.value) {
          await store.dispatch('obrazkiSvg/fetchImage', url.value);
        }
      },
      { immediate: true },
    );

    const iconReactive = computed(() => (svgIcon.value && svgIcon.value.svg ? svgIcon.value.svg : null));

    return {
      iconReactive,
      svgIcon,
      root,
    };
  },
});
